import { Badge } from '@components/badge';
import { Button } from '@components/button';
import { Card } from '@components/card';
import { IconCloseRegular } from '@components/icons/close-regular';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { pxToRem } from '@utils/converters';

type Step = {
  id: string;
  label: string;
  description: string;
};

export type StepWizardProps<Steps extends readonly Step[]> = {
  steps: Steps;
  currentStep: Steps[number]['id'];
  title: string;
  isFinished?: boolean;
  onDismiss?(): void;
};

export const StepWizard = <Steps extends readonly Step[]>({
  currentStep,
  title,
  steps,
  isFinished,
  onDismiss,
}: StepWizardProps<Steps>) => {
  const currentStepIndex = !isFinished
    ? steps.findIndex((step) => step.id === currentStep)
    : steps.length;

  return (
    <Card variant="gray" spaceX={4} spaceY={2}>
      <Stack space={2} style={{ marginBottom: pxToRem(8) }}>
        <Stack orientation="horizontal" space={2} align="center">
          <Button
            variant="ghost"
            text={title}
            onClick={onDismiss}
            iconRight={<IconCloseRegular />}
          />
        </Stack>
        <Stack orientation="horizontal" space={4}>
          {steps.map((step, index) => (
            <Card
              key={step.id}
              spaceX={6}
              spaceY={4}
              style={{ width: '204px', textAlign: 'center' }}
            >
              <Stack align="center" space={2}>
                <Badge
                  size="md"
                  isRounded
                  variant={
                    index > currentStepIndex
                      ? 'purple'
                      : index === currentStepIndex
                        ? 'blue'
                        : 'green'
                  }
                  text={index + 1}
                />
                <Stack align="center">
                  <Text text={step.label} font="bold12" />
                  <Text text={step.description} font="regular12" color="textSecondary" />
                </Stack>
              </Stack>
            </Card>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
};
